import axios from 'axios';
// collection endpoints are mounted at /api/collections on server (used only for add/remove)
const API_BASE_URL_COLLECTION = `${process.env.REACT_APP_API_URL}/api/collections`;

// Collection API endpoints
export const getAllCollectionsByCompanyApi = async (companyId) => {
  const body = { companyID: companyId };
  const response = await axios.post(`${API_BASE_URL_COLLECTION}/getCollectionsByCompany`, body);
  return response;
};

export const getCollectionDetailsApi = async (collectionId) => {
  const body = { collectionID: collectionId };
  const response = await axios.post(`${API_BASE_URL_COLLECTION}/getCollectionDetails`, body);
  return response;
};

export const addDriveToCollectionApi = async (collectionId, driveIds) => {
  const url = `${API_BASE_URL_COLLECTION}/${collectionId}/drive/add`;
  const body = { driveID: Array.isArray(driveIds) ? driveIds : [driveIds] };
  return await axios.post(url, body);
};

export const removeDriveFromCollectionApi = async (collectionId, driveIds) => {
  // removal sends driveID in body; supports single or multiple drives
  const url = `${API_BASE_URL_COLLECTION}/${collectionId}/drive/remove`;
  const body = { driveID: Array.isArray(driveIds) ? driveIds : [driveIds] };
  return await axios.post(url, body);
};

export const createCollectionApi = async (collectionData) => {
  const response = await axios.post(API_BASE_URL_COLLECTION, collectionData);
  return response;
};

export const updateCollectionApi = async (collectionData) => {
  const response = await axios.put(API_BASE_URL_COLLECTION, collectionData);
  return response;
};

export const fetchDatasetsForCollectionApi = async (collectionId) => {
  const response = await axios.get(`${API_BASE_URL_COLLECTION}/${collectionId}/dataset-id`);
  return response;
};
